// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"d78244a3","938":"5b946ad0"}[chunkId] + ".chunk.css";
};